import { z } from "@/zod";
import { ulid } from "@/schemas/commonFields";
import { nonNegativeDecimalStringSchema } from "@/schemas/commonFields/numberSchema";

export const costsFormSchema = z.object({
  costs: z.record(
    z.string(),
    z.object({
      id: ulid.optional(), // Optional for new costs, required for updates
      amount: nonNegativeDecimalStringSchema,
      name: z.string().trim().min(1).max(100),
      comment: z
        .string()
        .trim()
        .min(1)
        .max(250)
        .optional()
        .or(z.literal(""))
        .transform((val) => (val === "" ? undefined : val)),
      include: z.boolean(),
    }),
  ),
});

export type CostsFormSchemaType = z.infer<typeof costsFormSchema>;
